// ======================================================================
// FILE: src/modules/wms/routes/WMSRoutes.js
// MODULE: Work Management System (WMS)
// PURPOSE:
//   Route configuration for WMS module
// ======================================================================

import React from "react";

import {
  Routes,
  Route,
  Navigate,
} from "react-router-dom";

import WMSLayout
from "../WMSLayout";

// ======================================================================
// DASHBOARD
// ======================================================================

import WMSDashboardPage
from "../dashboard/pages/WMSDashboardPage";

import MyWorkPage
from "../my-work/MyWorkPage";

// ======================================================================
// TEAM MANAGEMENT
// ======================================================================

import TeamListPage
from "../team/pages/TeamListPage";

import TeamFormPage
from "../team/pages/TeamFormPage";

import TeamMembersPage
from "../team/pages/TeamMembersPage";


// ======================================================================
// CALENDAR MANAGEMENT
// ======================================================================

import CalendarListPage
from "../calendar/pages/CalendarListPage";

import CalendarFormPage
from "../calendar/pages/CalendarFormPage";


// ======================================================================
// SLA MANAGEMENT
// ======================================================================

import SLAPolicyListPage
from "../sla/pages/SLAPolicyListPage";

import SLAPolicyFormPage
from "../sla/pages/SLAPolicyFormPage";

// ======================================================================
// ESCALATION MANAGEMENT
// ======================================================================

import EscalationPolicyListPage
from "../escalation/pages/EscalationPolicyListPage";

import EscalationPolicyFormPage
from "../escalation/pages/EscalationPolicyFormPage";

// ======================================================================
// TEMPLATE MANAGEMENT
// ======================================================================

import TemplateListPage
from "../template/pages/TemplateListPage";

import TemplateFormPage
from "../template/pages/TemplateFormPage";


import ChecklistListPage
from "../checklist/pages/ChecklistListPage";

import ChecklistFormPage
from "../checklist/pages/ChecklistFormPage";


// ======================================================================
// WORK MANAGEMENT
// ======================================================================

import WorkListPage
from "../work/pages/WorkListPage";

import WorkFormPage
from "../work/pages/WorkFormPage";

import WorkDetailsPage
from "../work/pages/WorkDetailsPage";

// ======================================================================
// SCHEDULE
// ======================================================================
import RecurringScheduleListPage
    from "../recurringSchedules/pages/RecurringScheduleListPage";

import RecurringScheduleDetailsPage
    from "../recurringSchedules/pages/RecurringScheduleDetailsPage";

// ======================================================================
// EXECUTOR WORKSPACE
// ======================================================================

import ExecutorWorkspacePage
from "../workspace/executor/pages/ExecutorWorkspacePage";

import ExecutionWorkspacePage
from "../workspace/execution/pages/ExecutionWorkspacePage";

// ======================================================================
// REPORTS
// ======================================================================


import OpenWorkRegisterPage
from "../reports/pages/OpenWorkRegisterPage";

import ApprovalWorkspacePage
from "../workspace/approval/pages/ApprovalWorkspacePage";

import ApprovalWorkspaceListPage
from "../workspace/approval/pages/ApprovalWorkspaceListPage";


// ======================================================================
// ROUTES
// ======================================================================

export default function WMSRoutes() {

  return (

    <WMSLayout>

      <Routes>

        {/* ========================================================= */}
        {/* DEFAULT */}
        {/* ========================================================= */}

        <Route
          path="/"
          element={
            <Navigate
              //to="dashboard"
              to="my-work"
              replace
            />
          }
        />

        {/* ========================================================= */}
        {/* DASHBOARD */}
        {/* ========================================================= */}

        <Route
          path="dashboard"
          element={
            <WMSDashboardPage />
          }
        />
        <Route
          path="my-work"
          element={
            <MyWorkPage />
          }
        />
        {/* ========================================================= */}
        {/* TEAM LIST */}
        {/* ========================================================= */}

        <Route
          path="teams"
          element={
            <TeamListPage />
          }
        />

        {/* ========================================================= */}
        {/* CREATE TEAM */}
        {/* ========================================================= */}

        <Route
          path="teams/create"
          element={
            <TeamFormPage />
          }
        />

        {/* ========================================================= */}
        {/* EDIT TEAM */}
        {/* ========================================================= */}

        <Route
          path="teams/:id/edit"
          element={
            <TeamFormPage />
          }
        />

        {/* ========================================================= */}
        {/* TEAM MEMBERS */}
        {/* ========================================================= */}

        <Route
          path="teams/:id/members"
          element={
            <TeamMembersPage />
          }
        />

        {/* ========================================================= */}
        {/* CALENDAR LIST */}
        {/* ========================================================= */}

        <Route
          path="calendars"
          element={
            <CalendarListPage />
          }
        />

        {/* ========================================================= */}
        {/* CREATE CALENDAR */}
        {/* ========================================================= */}

        <Route
          path="calendars/create"
          element={
            <CalendarFormPage />
          }
        />

        {/* ========================================================= */}
        {/* EDIT CALENDAR */}
        {/* ========================================================= */}

        <Route
          path="calendars/:id/edit"
          element={
            <CalendarFormPage />
          }
        />
        
        
        {/* ========================================================= */}
        {/* SLA POLICY LIST */}
        {/* ========================================================= */}

        <Route
          path="sla-policies"
          element={
            <SLAPolicyListPage />
          }
        />

        {/* ========================================================= */}
        {/* CREATE SLA POLICY */}
        {/* ========================================================= */}

        <Route
          path="sla-policies/create"
          element={
            <SLAPolicyFormPage />
          }
        />

        {/* ========================================================= */}
        {/* EDIT SLA POLICY */}
        {/* ========================================================= */}

        <Route
          path="sla-policies/:id/edit"
          element={
            <SLAPolicyFormPage />
          }
        />
        
        {/* ========================================================= */}
        {/* ESCALATION POLICY LIST */}
        {/* ========================================================= */}

        <Route
          path="escalation-policies"
          element={
            <EscalationPolicyListPage />
          }
        />

        {/* ========================================================= */}
        {/* CREATE ESCALATION POLICY */}
        {/* ========================================================= */}

        <Route
          path="escalation-policies/create"
          element={
            <EscalationPolicyFormPage />
          }
        />

        {/* ========================================================= */}
        {/* EDIT ESCALATION POLICY */}
        {/* ========================================================= */}

        <Route
          path="escalation-policies/:id/edit"
          element={
            <EscalationPolicyFormPage />
          }
        />
        
        {/* ========================================================= */}
        {/* TEMPLATE LIST */}
        {/* ========================================================= */}

        <Route
          path="templates"
          element={
            <TemplateListPage />
          }
        />

        {/* ========================================================= */}
        {/* CREATE TEMPLATE */}
        {/* ========================================================= */}

        <Route
          path="templates/create"
          element={
            <TemplateFormPage />
          }
        />

        {/* ========================================================= */}
        {/* EDIT TEMPLATE */}
        {/* ========================================================= */}

        <Route
          path="templates/:id/edit"
          element={
            <TemplateFormPage />
          }
        />
        
        {/* ========================================================= */}
        {/* CHECKLIST LIST */}
        {/* ========================================================= */}

        <Route
          path="checklists"
          element={
            <ChecklistListPage />
          }
        />

        {/* ========================================================= */}
        {/* CREATE CHECKLIST */}
        {/* ========================================================= */}

        <Route
          path="checklists/create"
          element={
            <ChecklistFormPage />
          }
        />

        {/* ========================================================= */}
        {/* EDIT CHECKLIST */}
        {/* ========================================================= */}

        <Route
          path="checklists/:id/edit"
          element={
            <ChecklistFormPage />
          }
        />
        
        <Route
          path="works"
          element={
            <WorkListPage />
          }
        />

        <Route
          path="works/create"
          element={
            <WorkFormPage />
          }
        />

        <Route
          path="works/:id/edit"
          element={
            <WorkFormPage />
          }
        />
        <Route
          path="works/:id/details"
          element={
            <WorkDetailsPage />
          }
        />


        <Route
            path="recurring-schedules"
            element={
                <RecurringScheduleListPage />
            }
        />
        <Route
            path="recurring-schedules/:scheduleId"
            element={
                <RecurringScheduleDetailsPage />
            }
        />          
        {/* ========================================================= */}
        {/* EXECUTOR WORKSPACE */}
        {/* ========================================================= */}

        <Route
            path="executor-workspace"
            element={
                <ExecutorWorkspacePage />
            }
        />
        <Route
            path="works/:workId/execute"
            element={<ExecutionWorkspacePage />}
        />

        <Route
            path="works/:workId/approval"
            element={<ApprovalWorkspacePage />}
        />
        <Route
            path="approval-workspace"
            element={
                <ApprovalWorkspaceListPage />
            }
        />
        {/* ========================================================= */}
        {/* REPORTS */}
        {/* ========================================================= */}

        <Route

          path="reports/open-work-register"

          element={<OpenWorkRegisterPage />}


      />
        {/* ========================================================= */}
        {/* FALLBACK */}
        {/* ========================================================= */}

        <Route
          path="*"
          element={
            <Navigate
              t//o="/wms/dashboard"
              to="/wms/my-work"
              replace
            />
          }
        />

      </Routes>

    </WMSLayout>
  );
}